import { displayToast } from '../../../helpers/notification';
import { GCmembershipTypes as Type } from '../../types/gc-membership';

export function getGCmembershipListRequest(body: any) {
  return {
    type: Type.GET_GCMEMBERSHIP_LIST_REQUEST,
    body: body,
  };
}

export function getGCmembershipListRequestSuccess(data: any) {
  return {
    type: Type.GET_GCMEMBERSHIP_LIST_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getGCmembershipListRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.GET_GCMEMBERSHIP_LIST_REQUEST_FAILURE,
    error: error,
  };
}
